const PLMPhaseConfig = require('../../config/plmPhase.json');
const userRoleWizePermission = require('../../config/userPermisionNew.json');

export class PLMPhases {
    constructor() {
        this.stages = PLMPhaseConfig ? PLMPhaseConfig?.stages : [];
        this.stageTeamMapping = PLMPhaseConfig ? PLMPhaseConfig?.stage_team_mapping : {};
        this.userRoleTeamMapping = userRoleWizePermission ? userRoleWizePermission?.userRole : {};
    }


    buildUserTeamsObject(user) {
        console.log("user teams identification :", user);
        let userTeams = [];
        user.rolesAssigned.forEach((role) => {
            Object.keys(this.userRoleTeamMapping).forEach((team) => {
                if (this.userRoleTeamMapping[team].includes(role)) {
                    if (!userTeams.includes(team)) {
                        userTeams.push(team);
                    }
                }
            });
        });


        return userTeams;
    }


    getStageByUser(user) {
        console.log("user details", user);
        // console.log("user validity", user.rolesAssigned.find(
        //     (role) =>
        //         teamWizeRoleEligibility?.edit?.merchAttribute?.includes(
        //             role
        //         ) ||
        //         teamWizeRoleEligibility?.edit?.planningAttribute?.includes(
        //             role
        //         )
        // ));

    }

    getStageByUserTeams(userTeams) {
        /**
         * TO DO: logic to identify stage by user teams
         * userteams received as array for number of teams user belongs to
         * we need to identify most inclusive stage in plm for his access
         * e.g., if user belongs to merch team he should get access to development and QA  and receiving stage
         */
        console.log("user teams received for stage identification :", userTeams);
        let identifiedStage = {};
        Object.keys(this.stageTeamMapping).forEach((stage) => {
            const teamsForStage = this.stageTeamMapping[stage];
            const intersection = userTeams.filter(team => teamsForStage.includes(team));
            console.log("user team", userTeams, "stage :", stage, " | teams for stage :", teamsForStage, " | intersection :", intersection);
            if (intersection?.length > 0) {
                if (!identifiedStage["selectedStage"] || intersection.length >= identifiedStage["selectedStage"].length) {
                    identifiedStage["selectedStage"] = { stage: stage, length: intersection.length };
                }


            }


        });
        return identifiedStage["selectedStage"] ? identifiedStage["selectedStage"].stage : null;
    }


}


